import { BodyText, Button, Separator } from "@/components/ui";
import type { DiagnosticReport, ServiceRequest } from "@curai/js-fhir-tools";
import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import type { z } from "zod";
import {
  diagnosticReportFormSchema,
  manualResultFormSchema,
} from "../../schema";
import { DiagnosticReportDetails } from "./DiagnosticReportDetails";
import { ManualResultForm } from "./ManualResultForm";
import { UploadResultsReport } from "./UploadResultsReport";

export const ManualResulting = ({
  patientId,
  serviceRequest,
  existingDiagnosticReport,
}: {
  patientId: string;
  serviceRequest: ServiceRequest;
  existingDiagnosticReport?: DiagnosticReport;
}) => {
  const [addNewReport, setAddNewReport] = useState(!existingDiagnosticReport);

  const diagnosticReportForm = useForm<
    z.infer<typeof diagnosticReportFormSchema>
  >({
    resolver: zodResolver(diagnosticReportFormSchema),
    defaultValues: {
      files: [],
      reportReceivedDate: new Date(),
      reportStatus: undefined,
    },
  });

  const manualResultForm = useForm<z.infer<typeof manualResultFormSchema>>({
    mode: "onSubmit",

    resolver: zodResolver(manualResultFormSchema),
    defaultValues: {
      resultsList: [],
    },
  });

  return (
    <>
      {existingDiagnosticReport && !addNewReport && (
        <>
          <DiagnosticReportDetails
            diagnosticReport={existingDiagnosticReport}
          />
          <Button
            size="xs"
            className="w-fit"
            onClick={() => setAddNewReport(true)}
          >
            Add New Report
          </Button>
        </>
      )}
      {addNewReport && (
        <UploadResultsReport
          form={diagnosticReportForm}
          patientId={patientId}
          serviceRequestId={serviceRequest.id as string}
          onCancel={() => {
            diagnosticReportForm.reset();
            setAddNewReport(false);
          }}
          closeForm={() => {
            diagnosticReportForm.reset();
            setAddNewReport(false);
          }}
        />
      )}
      {existingDiagnosticReport && (
        <>
          <Separator />
          {addNewReport && (
            <BodyText size="sm" bold>
              Save the report before adding new results.
            </BodyText>
          )}
          <ManualResultForm
            disabled={addNewReport}
            form={manualResultForm}
            patientId={patientId}
            serviceRequestId={serviceRequest.id as string}
            diagnosticReportId={existingDiagnosticReport.id as string}
          />
        </>
      )}
    </>
  );
};
